/**
 * @file: 顶板tpl申明
 * @author: xiaolong.huang@dmall.com
 */

let tpl: string = `
    <div class="shelvesbuild-e-p-roof J_ElementPartitionRoofSlot slot is-partition" data-stagecore>
        <!-- 流动线 -->
        <span class="flow-border-left"><i></i></span>
        <span class="flow-border-right"><i></i></span>
        <span class="flow-border-top"><i></i></span>
        <span class="flow-border-bottom"><i></i></span>

        <!-- 实线边框 -->
        <span class="solid-border-left"></span>
        <span class="solid-border-right"></span>
        <span class="solid-border-top"></span>
        <span class="solid-border-bottom"></span>

        <div class="roof-tags">
            <div class="tags-text J_RoofTag"></div>
        </div>

        <span class="selected-mask"></span>

        <i class="is-in-stage"></i>
    </div>
`;

export default tpl;
